import React from "react";
import "./BannerBlogs.css";

export default function Blogs() {
  return (
    <section className="banner-blogs">
      <div className="banner-color-blogs">
        <div className="banner-content-blogs">
          <div className="banner-text-blogs">
            <h1 className="banner-title-blogs">Blogs</h1>
          </div>
        </div>
      </div>
    </section>
  );
}